import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllRomaneios = async (filters, page, size) => {
  try {
    const response = await api.get(`/romaneio`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createRomaneio = async (romaneioData) => {
  try {
    const response = await api.post('/romaneio', romaneioData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao criar romaneio.');
  }
};

export const getRomaneioData = async (romaneioId) => {
  try {
    const response = await api.get(`/romaneio/${romaneioId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados do romaneio.');
  }
};

export const updateRomaneio = async (romaneioId, data) => {
  try {
    const response = await api.put(`/romaneio/${romaneioId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar o romaneio.');
  }
};